<template>
  <v-app>
    <v-main>
      <!-- if using v-if, mounted will be called only once -->
      <!-- <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath + $route.meta.cacheCount" /> -->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <!-- <v-btn v-scroll="onScroll" v-show="fab" fab dark fixed bottom right color="primary" @click="toTop"><v-icon>keyboard_arrow_up</v-icon> </v-btn> -->
      <!-- <router-view></router-view> -->
    </v-main>
  </v-app>
</template>

<script>
import swUpdates from "@/mixins/swUpdates";

export default {
  name: "app",
  mixins: [swUpdates],
  data: () => ({
    // fab: false,
  }),
  created() {
    //SplashScreen.hide();
  },
  mounted() {
    if (window.google && window.google.accounts) {

    }
    //console.log('app mounted');
    // console.log(navigator);
  },
  methods: {
    // onScroll(e) {
    //   if (typeof window === "undefined") return;
    //   const top = window.pageYOffset || e.target.scrollTop || 0;
    //   this.fab = top > 20;
    // },
    // toTop() {
    //   this.$vuetify.goTo(0);
    // },
  },
};
</script>

<style>
/* select,
textarea,
input[type="text"],
input[type="password"],
input[type="datetime"],
input[type="datetime-local"],
input[type="date"],
input[type="month"],
input[type="time"],
input[type="week"],
input[type="number"],
input[type="email"],
input[type="url"],
input[type="search"],
input[type="tel"],
input[type="color"] {
  font-size: 16px;
} */

/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
/* html {
  background-color: #f4f4f4;
} */
:root {
  --content-margin-top: 46px;
  --content-margin-bottom: 46px;
}

#app {
  margin: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
  --margin-top: 20px;
}

body {
  color: #333;
  line-height: 1;
  /*background-color: #fafafa;*/
  font-family: "PingFang SC", Helvetica, "STHeiti STXihei", "Microsoft YaHei", Tohoma, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

/* .container {
   padding: 0!important;
} */
.header {
  box-shadow: 0px 2px 10px lightgrey;
  /* height: 44px; */
  height: calc(44px + env(safe-area-inset-top));
  padding-top: env(safe-area-inset-top);
  line-height: 44px;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
}

.content1 {
  margin-top: 46px;
  margin-bottom: 46px;
}

.content2 {
  margin-top: var(--content-margin-top);
  margin-bottom: var(--content-margin-bottom);
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
}

.bodyer {
  margin-top: 46px;
  margin-bottom: 46px;
}

/* #app {
  overflow-x: hidden; 
  height: 100%;
  background-color: #ffffff;
} */
.color_ea0000 {
  color: #ea0000;
}

.color_8b8b8b {
  color: #8b8b8b;
}

.color_ffffff {
  color: #ffffff;
}

.color_5f8dff {
  color: #5f8dff;
}

.color_8cdbcc {
  color: #8cdbcc;
}

.color_f4f4f4 {
  color: #f4f4f4;
}

.color_8cdbcc {
  color: #8cdbcc;
}

.color_background_8cdbcc {
  background-color: #8cdbcc;
}

.background_color_ff7f00 {
  background-color: #ff7f00 !important;
}

.background_color_eeeeee {
  background-color: #eeeeee;
}

.background_color_ffffff {
  background-color: #ffffff;
}

.background_color_d6f1ec {
  background-color: #d6f1ec !important;
}

.background_color_f4f4f4 {
  background-color: #f4f4f4;
}

.transparent {
  /* Required for IE 5, 6, 7 */
  /* ...or something to trigger hasLayout, like zoom: 1; */
  width: 100%;

  /* Theoretically for IE 8 & 9 (more valid) */
  /* ...but not required as filter works too */
  /* should come BEFORE filter */
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)";

  /* This works in IE 8 & 9 too */
  /* ... but also 5, 6, 7 */
  filter: alpha(opacity=50);

  /* Older than Firefox 0.9 */
  -moz-opacity: 0.5;

  /* Safari 1.x (pre WebKit!) */
  -khtml-opacity: 0.5;

  /* Modern!
	/* Firefox 0.9+, Safari 2?, Chrome any?
	/* Opera 9+, IE 9+ */
  opacity: 0.5;
}

.font_8 {
  font-size: 8px;
}

.font_10 {
  font-size: 10px;
}

.font_12 {
  font-size: 12px !important;
}

.font_14 {
  font-size: 14px;
}

.font_16 {
  font-size: 16px;
}

.font_18 {
  font-size: 18px;
}

.font_20 {
  font-size: 20px;
}

.font_24 {
  font-size: 24px;
}

.font_weight_bold {
  font-weight: bold;
}

.font_weight_bolder {
  font-weight: bolder;
}

.font_weight_lighter {
  font-weight: lighter;
}

.font_weight_normal {
  font-weight: normal;
}

.border_shadow {
  box-shadow: 0px 1px 10px lightgrey;
}

.border_top_1px {
  border-top: 1px solid #f4f4f4;
}

.border_bottom_e5e5e5 {
  border-bottom: 1px solid #e5e5e5;
}

.border_bottom_eeeeee {
  border-bottom: 1px solid #eeeeee;
}

.margin_5 {
  margin: 5px;
}

.margin_20 {
  margin: 20px;
}

.margin_top_2 {
  margin-top: 2px;
}

.margin_top_8 {
  margin-top: 8px;
}

.margin_top_10 {
  margin-top: 10px;
}

.margin_top_12 {
  margin-top: 12px;
}

.margin_bottom_50 {
  margin-bottom: 50px;
}

.margin_right_20 {
  margin-right: 20px;
}

.margin_right_50 {
  margin-right: 50px;
}

.padding_0 {
  padding: 0 !important;
}

.padding_2 {
  padding: 2px !important;
}

.padding_0_10 {
  padding: 0 10px;
}

.padding_5 {
  padding: 5px;
}

.padding_10 {
  padding: 10px;
}

.padding_10_0 {
  padding: 10px 0;
}

.padding_10_10 {
  padding: 0 10px 10px 10px;
}

.padding_20 {
  padding: 20px;
}

.padding_10_16 {
  padding: 10px 16px;
}

.padding_10_10_5_10 {
  padding: 10px 10px 5px 10px;
}

.padding_top_0 {
  padding-top: 0 !important;
}

.padding_top_5 {
  padding-top: 5px;
}

.padding_top_10 {
  padding-top: 10px;
}

.padding_bottom_0 {
  padding-bottom: 0 !important;
}

.padding_bottom_5 {
  padding-bottom: 5px !important;
}

.padding_bottom_10 {
  padding-bottom: 10px !important;
}

.padding_left_3 {
  padding-left: 3px;
}

.padding_left_5 {
  padding-left: 5px;
}

.padding_left_20 {
  padding-left: 20px;
}

.height_100 {
  height: 100px;
}

.width_20 {
  width: 20%;
}

.width_100 {
  width: 100%;
}

.float_left {
  float: left;
}

.float_right {
  float: right;
}

.float_clear_fix_ {
  overflow: auto;
}

.float_clear_fix::after {
  content: "";
  clear: both;
  display: table;
}

.text_left {
  text-align: left;
}

.text_center {
  text-align: center;
}

.text_right {
  text-align: right;
}

.btn_bottom {
  height: 50px;
  line-height: 50px;
}

.div_top_center {
  display: flex;
  align-items: center;
}

.img_top_center {
  vertical-align: text-top;
}

.img-text-top-middle {
  vertical-align: middle;
}

/**  sold out msg **/
/** container need position: relative, image needs position: absolute **/
.soldout {
  position: absolute;
  word-break: break-word;
  padding: 2px;
  border-radius: 25px;
  top: 5%;
  left: 5%;
  width: 80px;
  font-size: 16px;
  color: rgb(130, 130, 130);
  background-color: rgba(255, 255, 255, 0.5);
  /* transform: rotate(-30deg); 
  -webkit-transform: rotate(-30deg); /* Safari * /
  -moz-transform: rotate(-30deg); /* Firefox * /
  -ms-transform: rotate(-30deg); /* IE * /
  -o-transform: rotate(-30deg); /* Opera */
  z-index: 8;
  /* Make sure it does not overlap */
  /* right: 0; */
}

.soldout:after {
  content: "Sold Out";
}

/**  new produt msg **/
/** container need position: relative, image needs position: absolute **/
.comingsoon {
  position: absolute;
  word-break: break-word;
  padding: 2px;
  border-radius: 25px;
  top: 5%;
  left: 5%;
  width: 40%;
  font-size: 16px;
  color: rgb(130, 130, 130);
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 8;
  /* Make sure it does not overlap */
  /* right: 0; */
}

.comingsoon:after {
  content: "Coming Soon";
}

/**  new produt msg **/
.newcomer {
  position: absolute;
  word-break: break-word;
  padding: 2px;
  border-radius: 25px;
  top: 10%;
  left: 5%;
  font-size: 16px;
  font-weight: bold;
  color: rgb(236, 28, 28);
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 8;
}

.newcomer:after {
  content: "New";
}

/**  product **/
.product_list {
  padding: 5px;
}

.product_list .van-row {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
}

.product_info {
  margin: 3px 1px;
  /*  overflow: hidden; */
}

/* .product_image img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding: 5px;
  width: 90%;
  min-height: 90%;
} */
.product_info .product_image {
  position: relative;
  /* width: 100%; */
  /* vertical-align: middle; */
  /* border: 1px solid black; */
}

.product_info .product_image:before {
  display: block;
  content: "";
  padding-top: 100%;
}

.product_info .product_image img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  /* width: auto; */
  /* height: auto; */
}

.product_info .product_title {
  margin: 5px;
  /* height: 4em; */
  font-size: 11px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  /* white-space: nowrap; */
  /* padding: 3px; */
}

.product_info .product_footer {
  margin: 5px;
  /* padding-top: 5px; */
  height: 25px;
  font-size: 14px;
  text-align: center;
}

.product_info .product_footer_2 {
  margin: 5px;
  /* padding-top: 5px; */
  height: 40px;
  font-size: 14px;
  text-align: center;
}

.product_info .product_price {
  font-size: 16px;
  font-weight: bold;
  color: #f40;
}

.product_info .product_price_crossout {
  font-size: 16px;
  font-weight: bold;
  --color: #f40;
  text-decoration: line-through;
}

/**   **/
.van-doc-demo-block__title {
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  color: rgba(69, 90, 100, 0.6);
  padding: 40px 15px 15px;
}

.content-block {
  padding: 10px;
}

.my-bar {
  position: absolute;
  height: 46px;
  line-height: 46px;
  z-index: 1;
  padding: 10px;
}

.my-bar-left .arrow-left-con {
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 100%;
  background-color: rgba(93, 93, 93, 0.5);
  text-align: center;
}

.my-bar-left .arrow-left-con i {
  vertical-align: middle;
  font-size: 14px;
  color: white;
  font-weight: bold;
}

.my-sub-header {
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  line-height: 48px;
  padding-left: 16px;
  width: 100%;
  box-sizing: border-box;
}

.del_text {
  text-decoration: line-through;
}

.interval {
  height: 8px;
  background-color: #fafafa;
  width: 100%;
}

.van-nav-bar .van-icon {
  color: #ffffff !important;
  vertical-align: middle !important;
}

.more {
  /* xbottom: 100px;*/
  font-size: 12px;
}

.index-product-card {
  border-radius: 2px;
  overflow: hidden;
}
</style>
